module.exports = __webpack_public_path__ + "h5/img/index-opt1.276022ca.png";